// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WelcomePage.css - Exact Figma Layout */

.welcome-page {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 56px);
  background-color: #FFFFFF;
  overflow: auto;
}

/* Content wrapper - positions card and text side by side */
.welcome-content-wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 64px;
  padding: 32px;
  width: 100%;
  box-sizing: border-box;
}

/* Challenge Card - fixed size from Figma */
.challenge-card {
  position: relative;
  width: 546px;
  height: 473px;
  flex: 0 0 546px;
  border-radius: 40px;
  overflow: visible; /* Allow illustration to overflow */
}

/* Piggy bank illustration container - sized relative to card */
.piggybank-illustration {
  position: absolute;
  width: 69.4%; /* 379/546 from Figma */
  height: 52.9%; /* 250/473 from Figma */
  right: -14.3%; /* -78/546 - illustration extends past card */
  bottom: -22.2%; /* -105/473 - illustration extends below card */
  pointer-events: none;
  z-index: 2;
}

/* Individual piggy bank layers - positioned based on Figma specs */
.piggybank-bars {
  position: absolute;
  width: 81.96%;
  height: 127.41%;
  left: -18.7%;
  top: -19.25%;
  object-fit: contain;
}

.piggybank-body {
  position: absolute;
  width: 114.36%;
  height: 100%;
  left: -7.73%;
  top: 6.82%;
  object-fit: contain;
}

.piggybank-coins {
  position: absolute;
  width: 70.28%;
  height: 61.46%;
  left: 47.48%;
  top: 39.88%;
  object-fit: contain;
}

.challenge-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Text Content - takes remaining space */
.welcome-text-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;
  min-width: 300px;
  max-width: 800px;
}

.welcome-title {
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 900;
  font-size: 48px;
  line-height: 1.2;
  letter-spacing: -0.005em;
  color: #236CFF;
  margin: 0;
}

.welcome-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.welcome-body p {
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.6;
  color: #21262A;
  margin: 0;
}

/* Get Started Button - exact Figma specs */
.btn-get-started {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 136px;
  height: 48px;
  padding: 10px 24px;
  background-color: #00254B;
  border: none;
  border-radius: 9999px;
  cursor: pointer;
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.75;
  color: #FFFFFF;
  transition: background-color 0.2s ease;
}

.btn-get-started:hover {
  background-color: #001a35;
}

.btn-get-started:focus {
  outline: 2px solid #1C60EA;
  outline-offset: 2px;
}

/* Responsive - medium screens */
@media (max-width: 1100px) {
  .welcome-content-wrapper {
    flex-direction: column;
    gap: 32px;
  }

  .challenge-card {
    width: 100%;
    max-width: 546px;
    height: auto;
    flex: 0 0 auto;
    aspect-ratio: 546 / 473;
    overflow: visible;
    margin-bottom: 60px; /* Space for illustration overflow below card */
  }

  /* Scale down illustration at stacked layout - maintain 379/250 aspect ratio */
  .piggybank-illustration {
    width: 55%; /* Reduced from 69.4% */
    height: 42%; /* Reduced proportionally to maintain aspect ratio */
    right: -10%;
    bottom: -16%;
  }

  .welcome-text-content {
    max-width: 100%;
  }

  .welcome-title {
    font-size: 36px;
  }
}

/* Responsive - small screens / tablets */
@media (max-width: 768px) {
  .welcome-title {
    font-size: 28px;
  }

  .welcome-body p {
    font-size: 16px;
  }
}

/* Responsive - mobile */
@media (max-width: 680px) {
  .welcome-content-wrapper {
    padding: 16px;
    gap: 24px;
  }

  .challenge-card {
    max-width: 100%;
    aspect-ratio: 546 / 473;
    margin-bottom: 50px; /* Space for illustration overflow */
  }

  /* Further scale down on mobile */
  .piggybank-illustration {
    width: 50%;
    height: 38%;
    right: -8%;
    bottom: -14%;
  }

  .welcome-title {
    font-size: 24px;
  }

  .welcome-body p {
    font-size: 14px;
  }

  .btn-get-started {
    width: 100%;
    max-width: 200px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/WelcomePage.css"],"names":[],"mappings":"AAAA,yCAAyC;;AAEzC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,yBAAyB;EACzB,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,iBAAiB,EAAE,mCAAmC;AACxD;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,YAAY,EAAE,uBAAuB;EACrC,aAAa,EAAE,uBAAuB;EACtC,aAAa,EAAE,6CAA6C;EAC5D,cAAc,EAAE,+CAA+C;EAC/D,oBAAoB;EACpB,UAAU;AACZ;;AAEA,mEAAmE;AACnE;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,2CAA2C;AAC3C;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB,EAAE,+CAA+C;EACtE;;EAEA,8EAA8E;EAC9E;IACE,UAAU,EAAE,uBAAuB;IACnC,WAAW,EAAE,oDAAoD;IACjE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,mBAAmB,EAAE,oCAAoC;EAC3D;;EAEA,iCAAiC;EACjC;IACE,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF","sourcesContent":["/* WelcomePage.css - Exact Figma Layout */\n\n.welcome-page {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: calc(100vh - 56px);\n  background-color: #FFFFFF;\n  overflow: auto;\n}\n\n/* Content wrapper - positions card and text side by side */\n.welcome-content-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 64px;\n  padding: 32px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Challenge Card - fixed size from Figma */\n.challenge-card {\n  position: relative;\n  width: 546px;\n  height: 473px;\n  flex: 0 0 546px;\n  border-radius: 40px;\n  overflow: visible; /* Allow illustration to overflow */\n}\n\n/* Piggy bank illustration container - sized relative to card */\n.piggybank-illustration {\n  position: absolute;\n  width: 69.4%; /* 379/546 from Figma */\n  height: 52.9%; /* 250/473 from Figma */\n  right: -14.3%; /* -78/546 - illustration extends past card */\n  bottom: -22.2%; /* -105/473 - illustration extends below card */\n  pointer-events: none;\n  z-index: 2;\n}\n\n/* Individual piggy bank layers - positioned based on Figma specs */\n.piggybank-bars {\n  position: absolute;\n  width: 81.96%;\n  height: 127.41%;\n  left: -18.7%;\n  top: -19.25%;\n  object-fit: contain;\n}\n\n.piggybank-body {\n  position: absolute;\n  width: 114.36%;\n  height: 100%;\n  left: -7.73%;\n  top: 6.82%;\n  object-fit: contain;\n}\n\n.piggybank-coins {\n  position: absolute;\n  width: 70.28%;\n  height: 61.46%;\n  left: 47.48%;\n  top: 39.88%;\n  object-fit: contain;\n}\n\n.challenge-card-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* Text Content - takes remaining space */\n.welcome-text-content {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  flex: 1;\n  min-width: 300px;\n  max-width: 800px;\n}\n\n.welcome-title {\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 900;\n  font-size: 48px;\n  line-height: 1.2;\n  letter-spacing: -0.005em;\n  color: #236CFF;\n  margin: 0;\n}\n\n.welcome-body {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.welcome-body p {\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 1.6;\n  color: #21262A;\n  margin: 0;\n}\n\n/* Get Started Button - exact Figma specs */\n.btn-get-started {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: 136px;\n  height: 48px;\n  padding: 10px 24px;\n  background-color: #00254B;\n  border: none;\n  border-radius: 9999px;\n  cursor: pointer;\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 1.75;\n  color: #FFFFFF;\n  transition: background-color 0.2s ease;\n}\n\n.btn-get-started:hover {\n  background-color: #001a35;\n}\n\n.btn-get-started:focus {\n  outline: 2px solid #1C60EA;\n  outline-offset: 2px;\n}\n\n/* Responsive - medium screens */\n@media (max-width: 1100px) {\n  .welcome-content-wrapper {\n    flex-direction: column;\n    gap: 32px;\n  }\n\n  .challenge-card {\n    width: 100%;\n    max-width: 546px;\n    height: auto;\n    flex: 0 0 auto;\n    aspect-ratio: 546 / 473;\n    overflow: visible;\n    margin-bottom: 60px; /* Space for illustration overflow below card */\n  }\n\n  /* Scale down illustration at stacked layout - maintain 379/250 aspect ratio */\n  .piggybank-illustration {\n    width: 55%; /* Reduced from 69.4% */\n    height: 42%; /* Reduced proportionally to maintain aspect ratio */\n    right: -10%;\n    bottom: -16%;\n  }\n\n  .welcome-text-content {\n    max-width: 100%;\n  }\n\n  .welcome-title {\n    font-size: 36px;\n  }\n}\n\n/* Responsive - small screens / tablets */\n@media (max-width: 768px) {\n  .welcome-title {\n    font-size: 28px;\n  }\n\n  .welcome-body p {\n    font-size: 16px;\n  }\n}\n\n/* Responsive - mobile */\n@media (max-width: 680px) {\n  .welcome-content-wrapper {\n    padding: 16px;\n    gap: 24px;\n  }\n\n  .challenge-card {\n    max-width: 100%;\n    aspect-ratio: 546 / 473;\n    margin-bottom: 50px; /* Space for illustration overflow */\n  }\n\n  /* Further scale down on mobile */\n  .piggybank-illustration {\n    width: 50%;\n    height: 38%;\n    right: -8%;\n    bottom: -14%;\n  }\n\n  .welcome-title {\n    font-size: 24px;\n  }\n\n  .welcome-body p {\n    font-size: 14px;\n  }\n\n  .btn-get-started {\n    width: 100%;\n    max-width: 200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
